import { useEffect, useState } from 'react';
import './style.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';

function Wheather(){
    const[data,setData]=useState([]);
   
    const wheatherdata=async()=>{
        const url=`https://data.covid19india.org/data.json`
        const response= await fetch(url);
        const wdata=await response.json();
        setData(wdata.statewise);
    }
    useEffect(()=>{
        wheatherdata();
    },[])
   
    return(
        <>
        <h1 className="text-center txtall">INDIA <span className="txtcovid">COVID-19 Dashboard</span></h1>
       <table className="table table-hover  ">
  <thead className="thead-dark">
    <tr>
    <th scope="col">No.</th>
      <th scope="col">state</th>
      <th scope="col">confirmed</th>
      <th scope="col">recovered</th>
      <th scope="col">death</th>
      <th scope="col">active</th>
      <th scope="col">last updated time</th>

    </tr>
  </thead>
  <tbody>

   {data.map((val,indx)=>{
     return(
    <tr>
      <th scope="row">{indx}</th>
      <td>{val.state}</td>
      <td>{val.confirmed}</td>
      <td className="recover">{val.recovered}</td>
      <td className="death">{val.deaths}</td>
      <td>{val.active}</td>
      <td>{val.lastupdatedtime}</td>
    </tr>
     );
   }) }
    
   
    
  </tbody>
</table>



        </>
    
    );
}
export default Wheather;